import { render, staticRenderFns } from "./IconProfileCircle.vue?vue&type=template&id=3bed5ab9"
import script from "./IconProfileCircle.vue?vue&type=script&lang=js"
export * from "./IconProfileCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports